import React from "react";
import styled, { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  @import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.8/dist/web/variable/pretendardvariable-dynamic-subset.css');
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { font-family: 'Pretendard Variable', -apple-system, BlinkMacSystemFont, sans-serif; background: #F9FAFB; }
`;

const C = { primary: "#2563EB", accent: "#10B981", gray500: "#6B7280", gray700: "#374151", gray900: "#111827" };
const gradientBg = `linear-gradient(135deg, ${C.primary}, #1E40AF, ${C.accent})`;

const Header = styled.header`position:sticky;top:0;z-index:100;background:rgba(255,255,255,.95);backdrop-filter:blur(12px);border-bottom:1px solid #F3F4F6;`;
const HeaderInner = styled.div`max-width:900px;margin:0 auto;display:flex;align-items:center;justify-content:space-between;padding:0 24px;height:64px;`;
const Logo = styled.a`font-size:22px;font-weight:900;text-decoration:none;background:${gradientBg};-webkit-background-clip:text;-webkit-text-fill-color:transparent;`;
const BackLink = styled.a`font-size:14px;color:${C.gray500};text-decoration:none;&:hover{color:${C.primary};}`;

const Container = styled.main`max-width:900px;margin:0 auto;padding:48px 24px 80px;`;
const Title = styled.h1`font-size:32px;font-weight:800;color:${C.gray900};margin-bottom:8px;`;
const Updated = styled.p`font-size:14px;color:${C.gray500};margin-bottom:40px;`;
const Section = styled.section`margin-bottom:36px;`;
const H2 = styled.h2`font-size:20px;font-weight:700;color:${C.gray900};margin-bottom:12px;padding-bottom:8px;border-bottom:2px solid #E5E7EB;`;
const P = styled.p`font-size:15px;color:${C.gray700};line-height:1.8;margin-bottom:12px;`;
const Ol = styled.ol`padding-left:24px;margin-bottom:12px;`;
const Li = styled.li`font-size:15px;color:${C.gray700};line-height:1.8;margin-bottom:6px;`;
const Footer = styled.footer`background:${C.gray900};color:rgba(255,255,255,.4);text-align:center;padding:32px 24px;font-size:12px;line-height:1.8;`;

export default function Terms() {
  return (
    <>
      <GlobalStyle />
      <Header>
        <HeaderInner>
          <Logo href="/">Jumpin</Logo>
          <BackLink href="/">← 홈으로</BackLink>
        </HeaderInner>
      </Header>

      <Container>
        <Title>이용약관</Title>
        <Updated>시행일: 2026년 3월 21일 | 최종 수정: 2026년 3월 21일</Updated>

        <Section>
          <H2>제1조 (목적)</H2>
          <P>본 약관은 점핀주식회사(이하 "회사")가 제공하는 Jumpin 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</P>
        </Section>

        <Section>
          <H2>제2조 (정의)</H2>
          <Ol>
            <Li>"서비스"란 회사가 제공하는 중국 수출 채널 운영 자동화 및 해외 셀러 매칭 플랫폼을 의미합니다.</Li>
            <Li>"이용자"란 본 약관에 따라 회사가 제공하는 서비스를 이용하는 자를 말합니다.</Li>
            <Li>"회원"이란 회사에 개인정보를 제공하여 회원등록을 한 자로, 회사의 서비스를 계속적으로 이용할 수 있는 자를 말합니다.</Li>
            <Li>"채널"이란 도우인, 샤오홍슈, 티몰, 징동, 위챗, 콰이쇼우 등 중국 내 전자상거래 플랫폼을 의미합니다.</Li>
          </Ol>
        </Section>

        <Section>
          <H2>제3조 (약관의 효력 및 변경)</H2>
          <Ol>
            <Li>본 약관은 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력을 발생합니다.</Li>
            <Li>회사는 관련 법령에 위배되지 않는 범위에서 본 약관을 개정할 수 있으며, 개정 시 적용일자 및 개정사유를 명시하여 서비스 내에 7일 전부터 공지합니다.</Li>
            <Li>이용자가 변경된 약관에 동의하지 않는 경우, 서비스 이용을 중단하고 회원 탈퇴를 할 수 있습니다.</Li>
          </Ol>
        </Section>

        <Section>
          <H2>제4조 (서비스의 내용)</H2>
          <P>회사가 제공하는 서비스는 다음과 같습니다.</P>
          <Ol>
            <Li>중국 6대 채널(도우인, 샤오홍슈, 티몰, 징동, 위챗, 콰이쇼우) 통합 운영 서비스</Li>
            <Li>해외 셀러 매칭 서비스</Li>
            <Li>주문·재고·CS 자동화 서비스</Li>
            <Li>정산 및 성과 분석 서비스</Li>
            <Li>기타 회사가 추가 개발하거나 제휴를 통해 제공하는 서비스</Li>
          </Ol>
        </Section>

        <Section>
          <H2>제5조 (이용계약의 성립)</H2>
          <Ol>
            <Li>이용계약은 이용자가 본 약관의 내용에 동의하고 회원가입 신청을 하면, 회사가 이를 승낙함으로써 성립합니다.</Li>
            <Li>회사는 다음 각 호에 해당하는 경우 가입 신청을 거부하거나 사후 해지할 수 있습니다.
              <br />가. 실명이 아니거나 타인의 명의를 이용한 경우
              <br />나. 허위 정보를 기재한 경우
              <br />다. 기타 회사가 정한 가입 요건을 충족하지 못한 경우
            </Li>
          </Ol>
        </Section>

        <Section>
          <H2>제6조 (회원의 의무)</H2>
          <Ol>
            <Li>회원은 서비스 이용 시 관련 법령, 본 약관, 이용안내 등을 준수하여야 합니다.</Li>
            <Li>회원은 다음 행위를 하여서는 안 됩니다.
              <br />가. 타인의 정보 도용
              <br />나. 서비스에 게시된 정보의 무단 변경
              <br />다. 회사가 금지한 정보의 송신 또는 게시
              <br />라. 회사 및 제3자의 지식재산권 침해
              <br />마. 기타 불법적이거나 부당한 행위
            </Li>
          </Ol>
        </Section>

        <Section>
          <H2>제7조 (서비스 이용료)</H2>
          <Ol>
            <Li>서비스 이용료는 회사가 별도로 정한 요금제에 따릅니다.</Li>
            <Li>회사는 이용료를 변경할 수 있으며, 변경 시 30일 전에 공지합니다.</Li>
            <Li>이용료 미납 시 회사는 서비스 제공을 중단할 수 있습니다.</Li>
          </Ol>
        </Section>

        <Section>
          <H2>제8조 (서비스의 중단)</H2>
          <P>회사는 다음 각 호에 해당하는 경우 서비스 제공을 일시적으로 중단할 수 있습니다.</P>
          <Ol>
            <Li>설비의 보수, 점검, 교체 등 정기적 또는 긴급한 작업이 필요한 경우</Li>
            <Li>시스템 장애, 기간통신사업자의 서비스 중지 등 불가항력적 사유가 발생한 경우</Li>
            <Li>기타 회사의 합리적 판단에 의해 서비스 중단이 필요한 경우</Li>
          </Ol>
        </Section>

        <Section>
          <H2>제9조 (면책)</H2>
          <Ol>
            <Li>회사는 천재지변, 전쟁 등 불가항력적 사유로 인한 서비스 제공 불가에 대해 책임을 지지 않습니다.</Li>
            <Li>회사는 이용자의 귀책사유로 인한 서비스 이용 장애에 대해 책임을 지지 않습니다.</Li>
            <Li>회사는 이용자가 서비스를 이용하여 기대하는 수익을 얻지 못하거나 상실한 것에 대해 책임을 지지 않습니다.</Li>
          </Ol>
        </Section>

        <Section>
          <H2>제10조 (분쟁 해결)</H2>
          <Ol>
            <Li>본 약관에 관한 분쟁은 대한민국 법을 적용합니다.</Li>
            <Li>서비스 이용과 관련하여 발생한 분쟁에 대해서는 광주지방법원을 관할법원으로 합니다.</Li>
          </Ol>
        </Section>

        <Section>
          <H2>부칙</H2>
          <P>본 약관은 2026년 3월 21일부터 시행합니다.</P>
        </Section>
      </Container>

      <Footer>
        점핀주식회사 | 대표: 전지혜 | 사업자등록번호: 127-81-56735<br />
        광주광역시 임방울대로154-19 1층 | 이메일: biz@jumpin.kr<br />
        © {new Date().getFullYear()} Jumpin. All rights reserved.
      </Footer>
    </>
  );
}
